module.exports = __webpack_public_path__ + "media/images/illustrations/get-into-oxbridge-and-ivy-leagues-4cd9181cccf59ab2814b142cb484f64a.svg";